const styles = {
    profileLable: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
        width: '299px',
        mb: 1,
    },
    gridContainer: {
        display: 'grid',
        rowGap: 3,
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
    profileValue: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        color: '#001533',
        width: '299px',
        overflowWrap: 'break-word',
        whiteSpace: 'break-spaces',
    },
    profileButton: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '184px',
        height: '48px',
        mt: 5,
    },
    statusContainer: {
        mt: 2,
        mb: 3,
        display: 'flex',
    },
    statusText: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#001533',
        ml: 1,
    },
    addAddressContainer: {
        mt: 3,
        padding: 0,
    },
    addAddressText: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
        mr: 1,
    },
};
export default styles;
